// extracted by mini-css-extract-plugin
module.exports = {"description":"_3nhH9DXo943_Xlmmh20YlC"};